module.exports = __webpack_public_path__ + "static/media/ANKLE BELT (Gejje)-ink.e28b265c.jpeg";